// extracted by mini-css-extract-plugin
export default {"VideoPlayer":"_VideoPlayer--YEC3q","VideoElement":"_VideoElement--pRd0L"};